import classNames from 'classnames';
import { FC, FormHTMLAttributes, PropsWithChildren } from 'react';

import css from './form.module.scss';

interface Props extends FormHTMLAttributes<HTMLFormElement> {
  className?: string;
  isBgDefault?: boolean;
}

const Form: FC<PropsWithChildren<Props>> = ({ className, children, isBgDefault = false, ...rest }) => {
  return (
    <form
      className={classNames(
        'form',
        css.form,
        {
          [css.form_bgDefault]: isBgDefault,
        },
        className,
      )}
      {...rest}
    >
      {children}
    </form>
  );
};

export default Form;
